import factory from '@/api/factory'

export async function loadHandlers (platform) {
  return new Promise(resolve => {
    let i = platform.storeData.config.site.platforms.length

    if (!i) {
      return resolve()
    }

    for (const ref of platform.storeData.config.site.platforms) {
      const fullRef = `cms/platform/${ref}`

      if (window[fullRef] || document.getElementById(fullRef)) {
        continue
      }

      const url = `/platform/${ref}.client.js?c=${platform.storeData.cacheBust}`

      platform.fetch(url, { mode: 'no-cors', credentials: 'include' }).then(async res => {
        if (!res.ok) {
          throw new Error(`Handler ${ref} failed to load`)
        }

        let source = await res.text()

        source = source.replace('var __JOLOJO_GLOBAL__', `window['${fullRef}']`)

        const script = document.createElement('script')

        script.id = fullRef
        script.setAttribute('nonce', platform.storeData.nonce)
        script.textContent = platform.api.core.unsafe.trustedScript(source)

        document.head.appendChild(script)

        const module = window[fullRef]

        await module.main(platform, platform.router.host, factory)

        --i

        if (!i) {
          resolve()
        }
      })
    }
  })
}
